import "./PortfolioCard.scss"
import { Link } from "react-router-dom"

const PortfolioCard = ({ image, title, path, descr }) => {
  return (
    <div className="portfolio__card">
      <Link to={path} className="portfolio__link hover-effect-btn" rel="noopener noreferrer">
        <div className="portfolio__img">
          <img src={image} alt={title} />
        </div>
        <div className="overlay"></div>
        <h3 className="title">{title}</h3>
        <div className="button">
          <span>LINK</span>
        </div>
      </Link>
      <p className="descr">{descr}</p>
    </div>
  )
}

export default PortfolioCard
